var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgClientIndicator(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#00BAF9"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M14.166 8.463H12.44a2.147 2.147 0 00-.273-.753A2.024 2.024 0 0011 6.8a2.63 2.63 0 00-.807-.12c-.514 0-.97.13-1.367.389-.397.255-.708.63-.932 1.126-.225.492-.337 1.094-.337 1.805 0 .723.112 1.333.337 1.828.227.492.538.865.932 1.117.397.25.851.374 1.362.374.283 0 .548-.037.794-.11.25-.077.472-.19.67-.338a2.057 2.057 0 00.79-1.283l1.725.01a3.72 3.72 0 01-.42 1.264 3.73 3.73 0 01-.835 1.043 3.855 3.855 0 01-1.21.702c-.462.166-.974.25-1.537.25-.831 0-1.573-.193-2.225-.578-.653-.384-1.167-.94-1.542-1.666-.376-.726-.563-1.597-.563-2.613 0-1.019.189-1.89.567-2.613.379-.726.894-1.282 1.547-1.667.652-.384 1.391-.577 2.216-.577.526 0 1.016.074 1.468.222a3.76 3.76 0 011.21.65c.353.284.644.632.872 1.044.23.41.382.877.452 1.404z",
    fill: "#fff"
  })));
}
export default SvgClientIndicator;